<template>
  <aside
    class="@container/navigation sticky inset-y-0 hidden h-screen w-64 shrink-0 flex-col lg:flex"
  >
    <NuxtLink
      :to="{ name: 'dashboard' }"
      class="flex items-center gap-1 border-b border-zinc-950/5 px-4 py-5 text-sm font-medium text-zinc-700 hover:text-zinc-950"
    >
      <SvgoPikaChevronLeft class="size-5" />
      {{ $t("navigation.settings.back_to_app") }}
    </NuxtLink>
    <div class="overflow-y-auto p-3">
      <SettingsNavigationItems />
    </div>
  </aside>
</template>
